export default __webpack_public_path__ + "static/media/articleImageDefault.b3284e68.svg";